import setUpSchedule from "./setUpSchedule.js";
import setUpCustomization from './setUpCustomization.js';
import { omitProperties } from '../../utils/modules/omitProperties.js';
export default function transformRecurringToStore(recurring, domainId)
{
    if (!recurring || typeof recurring !== "object") {
        throw new Error("Invalid recurring: recurring must be a non-null object.");
    }

    if (!domainId && (typeof domainId === "string" || typeof domainId === "number")) {
        throw new Error("Invalid domain id: schedule must be a number or a string.");
    }

    let deepCopyOfRecurring = structuredClone(recurring);

    if (Object.prototype.hasOwnProperty.call(deepCopyOfRecurring, "schedules")) {
        deepCopyOfRecurring.schedule = deepCopyOfRecurring.schedules[0];
        delete deepCopyOfRecurring.schedules;
    }

    deepCopyOfRecurring.audiences = deepCopyOfRecurring.schedule.audiences.length ?
        deepCopyOfRecurring.schedule.audiences.map(({ name, query }) =>
        ({
            domain_id: domainId,
            name,
            query
        })) : [];

    deepCopyOfRecurring.schedule = setUpSchedule(deepCopyOfRecurring.schedule, domainId);
    deepCopyOfRecurring.customization = setUpCustomization(deepCopyOfRecurring.customization);

    deepCopyOfRecurring.domain_id = domainId;

    deepCopyOfRecurring = omitProperties(deepCopyOfRecurring, ["created_at", "deleted_at", "updated_at", "drip_number", "external", "event", "id", "group_id"]);

    return deepCopyOfRecurring;
}